<!-- Vue component -->
<template>
    <div>
        <ListSelect
            aria-required="true"
            :options="options"
            :placeholder="placeholder"
            :id="id"
            :name="name">
        </ListSelect>
    </div>
</template>

<script>
    import ListSelect from 'vue-search-select/src/lib/ListSelect';


    export default {
        components: {ListSelect},
        name: 'SimpleSearchSelect',
        props: {
            options: Array,
            placeholder: String,
            id: String,
            callback: Function,
            name: String
        },
        data() {
            return {
                value: this.selecteddata,
            }
        },
        computed: {
            getValue() {
                return this.value;
            },
            getValuesArray() {
                return this.value.flatMap(function (item) {
                    return item.value
                });
            }
        },
        watch: {
            value: {
                immediate: false,
                handler(val, oldVal) {
                    this.callback ? this.callback(this.$el) : '';
                }
            },
            /*selecteddata: {
                immediate: true,
                handler (val, oldVal) {
                    if (val !== undefined) {
                        this.value = val;
                    }
                }
            }*/
        }
    }
</script>

<style>
</style>
